import router from '@/router'
import { listH5Pages } from '@/api/h5Pages'
// import Layout from '@/layout/index'
// import ParentView from '@/components/ParentView';

const page = {
    state: {
        pages: []
    },
    mutations: {
        SET_PAGES: (state, pages) => {
            state.pages = pages
        }
    },
    actions: {
        // 生成路由
        ListH5PagesByAppletId ({ commit }, _appletId) {
            return new Promise(resolve => {
                // 向后端请求路由数据
                listH5Pages({ appletId: _appletId }).then(res => {
                    commit('SET_PAGES', res.data)
                    resolve(res.data)
                })
            })
        }
    }
}

export default page



// WEBPACK FOOTER //
// ./src/store/modules/page.js